<template>
    <div>
        <div class="treveler-service-name align-center">
            <icon name="umbrella" width="21px" height="18px" fill="var(--lighten-5-color)"/>

            <span class="ml-6 mr-6">{{ localizeList.insuranceUpper }}</span>
            <!-- <div>
                <icon name="info" width="20px" height="20px" fill="var(--lighten-5-color)"/>
            </div> -->
        </div>

        <div class="select-wrap"
             @mouseleave="hover = false"
             @mouseover="hover = true">
            <div @click="toggleList()" class="select align-center justify-between">
                {{ selectedTitle || label }}

                <div class="align-center">
                    <span class="blue-text">{{costChanged}}</span>
                    <icon name="drop-angle"
                          :class="['drop-icon', {'rotate': showList}]"
                          width="10px" height="5px" fill="var(--lighten-5-color)"/>
                </div>
            </div>
            <div class="drop-down-list"
                 v-show="showList">
                <div v-for="(item, key) in insuranceServices"
                     :key="key"
                     class="drop-down-group">
                    <!-- <h4 class="standard-500-text mb-2">{{item.title}}</h4> -->
                    <div class="drop-down-group-list">
                        <div v-for="(item2, key2) in item.items"
                             :key="`${key}_${key2}`"
                             :class="['drop-down-item align-center justify-between', {'active': checkIsSelected(item, item2)}]"
                             @click="changeItem(key, key2, item2)">
                            <h4 v-if="item2.value !== 0" class="drop-down-item-title">{{item2.title}}</h4>
                            <div class="drop-down-item-labels">
                              <span class="main-label">{{item2.label}}</span>
                              <span v-if="!checkIsSelected(item, item2)" class="second-label nowrap">{{item2.secondLabel}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "insurance",
        props: {
            services: {
                type: Array,
                required: true
            },
            insuranceItems: {
                type: Array,
                required: true
            },
            insuranceValue: {
                type: Array,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            tourRate: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                showList: false,
                hover: false,
                select: 0,
                insuranceServices: [],
                titles: [],
                oldSelectedItems : [],
            }
        },
        computed: {
            costChanged() {
                let res = 0;
                if (!this.insuranceServices.length) return res;

                this.insuranceServices.forEach(x => {
                    // const defaultCost = typeof x.items[0].cost === "number" ?
                    //         x.items[0].cost : x.items[0].Cost;

                    const selectedCost = typeof x.selectedItem.cost === "number" ?
                            x.selectedItem.cost : x.selectedItem.Cost;

                    if (x.items[0].value === 0) res = selectedCost 
                    // res += selectedCost - defaultCost
                });

                return res > 0 ?
                        `+${this.correctPrice(res, true)} ${this.tourRate}` : ''
            },
            selectedTitle() {
                return this.titles.filter(item => item).join(', ')
            },
            label() {
                let res = '';
                let notRequireTitle = '';
                this.insuranceServices.forEach(x => {
                    if (x.selectedItem.allData) {
                        res += (res ? ', ' : '') + x.selectedItem.title
                    } else {
                        notRequireTitle = x.selectedItem.label
                    }
                });
                return res || notRequireTitle
            },
        },
        mounted() {
            this.setInsuranceServices()
        },
        methods: {
            setInsuranceServices() {
                const insuranceServices = this.services.filter(x => x.svKey === 6);
                this.insuranceServices = JSON.parse(JSON.stringify(insuranceServices));
                const items = this.insuranceItems[this.index];

                this.insuranceServices.map((x, i) => {
                    x.items = JSON.parse(JSON.stringify(items[i]));

                    const canAdd = x.items.some(subservice => {
                        if (!subservice.serviceAllData) return;
                        const { IsNotCalculate, IsDeleted} = subservice.serviceAllData
                        return  !IsDeleted || (IsDeleted && !IsNotCalculate)
                    }); 

                    const oldSelectedItem = x.items.find(el => el.value === this.oldSelectedItems[i])

                    if(oldSelectedItem){
                        x.selectedItem = oldSelectedItem;
                    } else {
                        x.selectedItem = canAdd ? x.items.find((el) => el.value) : 0;
                    }

                    this.titles[i] = x.selectedItem?.title || null
                    return x
                });

                this.oldSelectedItems = this.insuranceServices.map(x => x.selectedItem?.value || 0);
                this.$emit('changeTrevelerService', [this.oldSelectedItems, 0])
            },
            checkIsSelected(item, item2) {
                return item2.label +''+ item2.value === item.selectedItem.label +''+ item.selectedItem.value
            },
            changeItem(key, key2, item2) {
              this.titles[key] = item2.title
              const cost = item2.cost;

                this.hideList();
                this.insuranceServices = this.insuranceServices.map((x, i) => {
                    if (key === i) {
                        x.selectedItem = x.items.find((x2, i2) => i2 === key2);
                        x.items = x.items.map(x2 => {
                            x2.secondLabel = (x2.cost - cost < 0 || x2.cost - cost === 0) ?
                                `${this.correctPrice(x2.cost - cost, true)} ${this.tourRate}` :
                                `+${this.correctPrice(x2.cost - cost, true)} ${this.tourRate}`;

                            return x2
                        })
                    }

                    return x
                });

                this.oldSelectedItems = this.insuranceServices.map(x => x.selectedItem?.value || 0);
                this.$emit('changeTrevelerService', [this.oldSelectedItems, key])
            },
            toggleList() {
                this.showList = !this.showList;
            },
            hideList() {
                this.showList = false;
            },
            outside() {
                if (!this.hover) {
                    this.hideList();
                }
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            showPopover(text, e) {
                let rect = e.target.getBoundingClientRect()
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height
                }
                this.$store.dispatch('A_SHOW_POPOVER', res);
            },
        },
        watch: {
            services() {
                this.setInsuranceServices()
            },
            showList(val) {
                if (val) {
                    window.addEventListener("click", this.outside);
                } else {
                    window.removeEventListener("click", this.outside);
                }
            }
        }
    }
</script>

<style scoped>

    .select-wrap {
        position: relative;
        width: 100%;
    }
    .select-wrap .second-label {
        color: var(--primary-color);
    }

    .select-wrap .select {
        position: relative;
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 26px 8px 12px;
        background-color: var(--white-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        cursor: pointer;
    }

    .select-wrap .select .drop-icon{
        position: absolute;
        top: calc(50% - 2px);
        right: 11px;
        transition: all .2s;
    }
    .select-wrap .select .drop-icon /deep/ svg {
        position: absolute;
        top: 0;
        right: 0;
    }

    .select-wrap .select .drop-icon.rotate {
        transform: rotate(180deg)
    }

    .select-wrap .drop-down-list {
        min-width: 100%;
        max-height: 136px;
        overflow: auto;
        position: absolute;
        top: 100%;
        left: 0;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 4px 0;
        background-color: var(--white-color);
        z-index: 10;
    }

    .select-wrap .drop-down-group {
        padding: 6px 10px;
    }
    .select-wrap .drop-down-group:not(:last-child) {
        border-bottom: 1px solid #dddddd;
    }

    .select-wrap .drop-down-list .drop-down-group-list {
        display: flex;
        flex-direction: column;
    }

    .select-wrap .drop-down-list .drop-down-item {
        flex-direction: column;
        align-items: flex-start;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        padding: 4px 12px;
        transition: all .2s;
        cursor: pointer;
        gap: 5px;
    }

    .select-wrap .drop-down-list .drop-down-item .drop-down-item-title {
        padding-top: 4px;
        margin-bottom: 4px;
    }

    .select-wrap .drop-down-list .drop-down-item .drop-down-item-labels {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .select-wrap .drop-down-list .drop-down-item .drop-down-item-labels .main-label{
        font-weight: 400;
    }

    .select-wrap .drop-down-list .drop-down-item:hover,
    .select-wrap .drop-down-list .drop-down-item.focus {
        background-color: rgba(229, 243, 253, .5);
    }
    .select-wrap .drop-down-list .drop-down-item.active {
        background-color: var(--primary-2-color);
    }
</style>